<template>
    <div class="bar-all-sty"> 
         <div class="bar-back" v-for="ba in barCharList" :style="width">
            <div class="bar-sty" :id="ba.id">
                <img class="t-center" v-if="ba.list == null || ba.list == ''"  style="margin-top:200px" src="../assets/images/roll.gif" width="40">
            </div>  
        </div>
    </div>
</template>

<script> 
export default {
    props:['barCharLists'],
    data () {
        return { 
             barCharList:this.barCharLists,
             bmapList:[],
             width: {
                width: '',
             },
        }
    },
    methods: {  
        //柱形图
        getBar(id,daanalysisChartNameta,lists){
            let myChart = this.$echarts.init(document.getElementById(id));  
            let names = [];
            if(lists.itemYAxis != null && lists.itemYAxis.length > 0){
                lists.itemYAxis.forEach((i)=>{
                    names.push(i.name);
                })
            }
            let option = {
                color: ['#a3d9d3', '#669cdb', '#5b5bfd', '#9166c3', '#dd6c5c','#f8c073','#8ad574'],
                title: {
                    text: daanalysisChartNameta,
                    left: '30px', 
                    top: '30px',
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross',
                        crossStyle: {
                            color: '#999'
                        }
                    }
                },
                toolbox: {
                    // top:'30px',
                    itemSize:25,
                    feature: {
                        saveAsImage: {
                            show: true,
                            pixelRatio: 2, // 保存图片的分辨率比例，可以设置为大于 1 的值
                            backgroundColor:  'rgba(128, 128, 128, 0)',
                            
                        }
                    }, 
                },
                legend: {
                    orient: 'horizontal', 
                    top:60, 
                    itemWidth:10, 
                    textStyle:{
                        fontSize: 14
                    },
                    right:40,
                    itemGap:20,   
                    data:names 
                },
                grid: {
                    left: '120',
                    top: '120px',
                    right:'40',
                    bottom:'12%'
                },
                xAxis: {
                    type: 'category',
                    splitLine :{    //网格线
                        lineStyle:{
                            type:'dashed'    //设置网格线类型 dotted：虚线   solid:实线
                        },
                        show:false //隐藏或显示
                    },
                    data: lists.itemXAxis[0].data
                },
                yAxis: {
                        type: 'value', 
                        splitLine :{    //网格线
                            lineStyle:{
                                type:'dashed'    //设置网格线类型 dotted：虚线   solid:实线
                            },
                            show:true //隐藏或显示
                        },
                        "axisLine":{       //y轴
                            "show":false 
                        }, 
                },
                series: lists.itemYAxis
            }; 
            option && myChart.setOption(option,true);
        },
        //柱形图+折线
        getBarAndLine(id,daanalysisChartNameta,lists){ 
            let myChart = this.$echarts.init(document.getElementById(id)); 
            let names = [];
            if(lists.itemYAxis != null && lists.itemYAxis.length > 0){
                lists.itemYAxis.forEach((i)=>{
                    if(i.type == 'line'){
                        i.yAxisIndex = 1;
                    }
                    names.push(i.name);
                })
            } 
            let option = {
                color: ['#a3d9d3', '#669cdb', '#5b5bfd', '#9166c3', '#dd6c5c','#f8c073','#8ad574'],
                title: {
                    text: daanalysisChartNameta,
                    left: '30px', 
                    top: '30px',
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross',
                        crossStyle: {
                            color: '#999'
                        }
                    }
                },
                toolbox: {
                    itemSize:25,
                    feature: {
                        saveAsImage: {
                            show: true,
                            pixelRatio: 2, // 保存图片的分辨率比例，可以设置为大于 1 的值
                            backgroundColor:  'rgba(128, 128, 128, 0)'  
                        }
                    }
                },
                legend: {
                    orient: 'horizontal',
                    top:60, 
                    itemWidth:10, 
                    textStyle:{
                        fontSize: 14
                    },
                    right:40,
                    itemGap:20,  
                    data:names
                },
                grid: {
                    left: '120',
                    top: '120px',
                    right:'60',
                    bottom:'12%'
                },
                xAxis: { 
                    type: 'category',
                    splitLine :{    //网格线
                        lineStyle:{
                            type:'dashed'    //设置网格线类型 dotted：虚线   solid:实线
                        },
                        show:false //隐藏或显示
                    },
                    data: lists.itemXAxis[0].data
                },
                yAxis: [
                    {
                        type: 'value', 
                        // min: 0,
                        splitLine :{    //网格线
                            lineStyle:{
                                type:'dashed'    //设置网格线类型 dotted：虚线   solid:实线
                            },
                            show:true //隐藏或显示
                        },
                        "axisLine":{       //y轴
                            "show":false 
                        }, 
                        // max: 100000000, 
                    },
                    {
                        type: 'value', 
                        // min: 0,
                        splitLine :{    //网格线
                            lineStyle:{
                                type:'dashed'    //设置网格线类型 dotted：虚线   solid:实线
                            },
                            show:false //隐藏或显示
                        },
                        "axisLine":{       //y轴
                            "show":false 
                        }, 
                        // max: 5000,
                        // interval: 5,
                    }
                ],
                series: lists.itemYAxis
            }; 
            option && myChart.setOption(option,true);
        },
        //饼图
        getPie(id,daanalysisChartNameta,lists){
            let myChart = this.$echarts.init(document.getElementById(id)); 
            let option = {
                color: ['#a3d9d3', '#669cdb', '#5b5bfd', '#9166c3', '#dd6c5c','#f8c073','#8ad574'],
                title: {
                    text: daanalysisChartNameta,
                    left: '30px', 
                    top: '30px',
                },
                tooltip: {
                    trigger: 'item'
                },
                toolbox: {
                    itemSize:25,
                    feature: {
                        saveAsImage: {
                            show: true,
                            pixelRatio: 2, // 保存图片的分辨率比例，可以设置为大于 1 的值
                            backgroundColor:  'rgba(128, 128, 128, 0)'  
                        }
                    }
                },
                legend: {
                    orient: 'vertical',
                    top:60, 
                    itemWidth:10, 
                    textStyle:{
                        fontSize: 14
                    },
                    right:40,
                    itemGap:20,  
                },
                grid: {
                    left: '120',
                    top: '120px',
                    right:'40',
                    bottom:'12%'
                },
                series: [
                    {
                        name: '数据来源',
                        type: 'pie',
                        radius: '50%',
                        data: lists,
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        }
                    }
                ]
            };
            option && myChart.setOption(option,true);
        },
        //堆叠图
        getBarMore(id,daanalysisChartNameta,lists){
            let myChart = this.$echarts.init(document.getElementById(id)); 
            let names = [];
            if(lists.itemXAxis != null && lists.itemXAxis.length > 0){
                lists.itemXAxis.forEach((i)=>{
                    names.push(i.name);
                })
            }
            let option = {
                color: ['#a3d9d3', '#669cdb', '#5b5bfd', '#9166c3', '#dd6c5c','#f8c073','#8ad574'],
                title: {
                    text: daanalysisChartNameta,
                    left: '30px', 
                    top: '30px',
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross',
                        crossStyle: {
                            color: '#999'
                        }
                    }
                },
                toolbox: {
                    itemSize:25,
                    feature: {
                        saveAsImage: {
                            show: true,
                            pixelRatio: 2, // 保存图片的分辨率比例，可以设置为大于 1 的值
                            backgroundColor:  'rgba(128, 128, 128, 0)'  
                        }
                    }
                },
                legend: {
                    orient: 'horizontal', 
                    top:60, 
                    itemWidth:10, 
                    textStyle:{
                        fontSize: 14
                    },
                    right:40,
                    itemGap:20,  
                    data: names,
                }, 
                grid: {
                    left: '120',
                    top: '120px',
                    right:'40',
                    bottom:'12%'
                },
                xAxis: {
                    type: 'value',
                    splitLine :{    //网格线
                        lineStyle:{
                            type:'dashed'    //设置网格线类型 dotted：虚线   solid:实线
                        },
                        show:true //隐藏或显示
                    },
                    "axisLine":{       //y轴
                        "show":false 
                    }
                },
                yAxis: {
                    type: 'category',
                    splitLine :{    //网格线
                        lineStyle:{
                            type:'dashed'    //设置网格线类型 dotted：虚线   solid:实线
                        },
                        show:false //隐藏或显示
                    },
                    "axisLine":{       //y轴
                        "show":false 
                    },
                    data: lists.itemYAxis[0].data
                },
                series: lists.itemXAxis
            };
            option && myChart.setOption(option,true);
        },
        //气泡图
        getScatter(id,daanalysisChartNameta,lists){ 
            let myChart = this.$echarts.init(document.getElementById(id)); 
            let data = [lists];
            let option = { 
                color: ['#a3d9d3', '#669cdb', '#5b5bfd', '#9166c3', '#dd6c5c','#f8c073','#8ad574'],
                title: {
                    text: daanalysisChartNameta,
                    left: '30px', 
                    top: '30px',
                },
                legend: {
                    orient: 'horizontal', 
                    top:60, 
                    itemWidth:10, 
                    textStyle:{
                        fontSize: 14
                    },
                    right:20,
                    itemGap:20, 
                    // data: ['产品数']
                },
                toolbox: {
                    itemSize:25,
                    feature: {
                        saveAsImage: {
                            show: true,
                            pixelRatio: 2, // 保存图片的分辨率比例，可以设置为大于 1 的值
                            backgroundColor:  'rgba(128, 128, 128, 0)'  
                        }
                    }
                },
                grid: {
                    left: '120',
                    top: '120px',
                    right:'40',
                    bottom:'12%'
                },
                xAxis: {
                    splitLine: {
                        lineStyle: {
                            type: 'dashed'
                        }
                    }
                },
                yAxis: {
                    splitLine: {
                        lineStyle: {
                            type: 'dashed'
                        }
                    },
                    scale: true
                },
                series: [{
                    // name: '产品数',
                    data: data[0],
                    type: 'scatter', 
                    symbolSize: function (data) {
                        return Math.sqrt(data[2]) / 5e2;
                    },
                    emphasis: {
                        focus: 'series',
                        label: {
                            show: true,
                            formatter: function (param) {
                                return param.data[3];
                            },
                            position: 'top'
                        }
                    },
                    itemStyle: {
                        shadowBlur: 10,
                        shadowColor: 'rgba(163, 217, 211, 0.1)',
                        shadowOffsetY: 5,
                        color: new this.$echarts.graphic.RadialGradient(0.4, 0.3, 1, [{
                            offset: 0,
                            color: 'rgb(163, 217, 211, 0.9)'
                        }])
                    }
                }]
            };
            option && myChart.setOption(option,true);
        }, 
        //散点图
        getScatterSome(id,daanalysisChartNameta,lists){
            let myChart = this.$echarts.init(document.getElementById(id));
            let option = {
                color: ['#a3d9d3'],
                title: {
                    text: daanalysisChartNameta,
                    left: '30px', 
                    top: '30px',
                }, 
                toolbox: {
                    itemSize:25,
                    feature: {
                        saveAsImage: {
                            show: true,
                            pixelRatio: 2, // 保存图片的分辨率比例，可以设置为大于 1 的值
                            backgroundColor:  'rgba(128, 128, 128, 0)'  
                        }
                    }
                },
                grid: {
                    left: '120',
                    top: '120px',
                    right:'40',
                    bottom:'12%'
                },
                xAxis: {
                    splitLine: {
                        lineStyle: {
                            type: 'dashed'
                        }
                    }
                },
                yAxis: {
                    splitLine: {
                        lineStyle: {
                            type: 'dashed'
                        }
                    },
                    scale: true
                },
                series: [{
                    symbolSize: 20,
                    data: lists,
                    type: 'scatter'
                }]
            };
            option && myChart.setOption(option,true);
        },
        //堆叠折线图
        getScatterSomeAndLine(id,daanalysisChartNameta,lists){
            let myChart = this.$echarts.init(document.getElementById(id));
            let names = [];
            if(lists.itemYAxis != null && lists.itemYAxis.length > 0){
                lists.itemYAxis.forEach((i)=>{
                    if(i.type == 'line'){
                        i.yAxisIndex = 1;
                    }
                    i.stack = 'total';
                    names.push(i.name);
                })
            }
            let option = {
                color: ['#a3d9d3', '#669cdb', '#5b5bfd', '#9166c3', '#dd6c5c','#f8c073','#8ad574'],
                title: {
                    text: daanalysisChartNameta,
                    left: '30px', 
                    top: '30px',
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross',
                        crossStyle: {
                            color: '#999'
                        }
                    }
                },
                toolbox: {
                    itemSize:25,
                    feature: {
                        saveAsImage: {
                            show: true,
                            pixelRatio: 2, // 保存图片的分辨率比例，可以设置为大于 1 的值
                            backgroundColor:  'rgba(128, 128, 128, 0)'  
                        }
                    }
                },
                legend: {
                    orient: 'horizontal', 
                    top:60, 
                    itemWidth:10, 
                    textStyle:{
                        fontSize: 14
                    },
                    right:20,
                    itemGap:20, 
                    data: names,
                },
                grid: {
                    left: '120',
                    top: '120px',
                    right:'40',
                    bottom:'12%'
                },
                // legend: {
                //     data: ['直接访问', '邮件营销', '联盟广告', '视频广告', '搜索引擎', '百度', '谷歌', '必应', '其他']
                // }, 
                xAxis: [
                    {
                        type: 'category',
                        splitLine :{    //网格线
                            lineStyle:{
                                type:'dashed'    //设置网格线类型 dotted：虚线   solid:实线
                            },
                            show:false //隐藏或显示
                        },
                        "axisLine":{       //y轴
                            "show":true 
                        }, 
                        data: lists.itemXAxis[0].data
                    }
                ],
                yAxis: [
                    {
                        type: 'value', 
                        splitLine :{    //网格线
                            lineStyle:{
                                type:'dashed'    //设置网格线类型 dotted：虚线   solid:实线
                            },
                            show:true //隐藏或显示
                        },
                        "axisLine":{       //y轴
                            "show":true 
                        }, 
                        min: 0,
                        // max: 100000000, 
                    },
                    {
                        type: 'value', 
                        splitLine :{    //网格线
                            lineStyle:{
                                type:'dashed'    //设置网格线类型 dotted：虚线   solid:实线
                            },
                            show:false //隐藏或显示
                        },
                        "axisLine":{       //y轴
                            "show":true 
                        }, 
                        min: 0,
                        // max: 5000,
                        // interval: 5,
                    }
                ],
                series: lists.itemYAxis
            };
            option && myChart.setOption(option,true);
        },
        getBmap(id,daanalysisChartNameta,bmapList){
          let myChart = this.$echarts.init(document.getElementById(id));  
          console.log("地图数据结果",bmapList);
          function randomValue() {
                return Math.round(Math.random()*1000);
            };
          let option = {
              title: {
                    text: daanalysisChartNameta,
                    left: '30px', 
                    top: '30px',
                },
                toolbox: {
                    itemSize:25,
                    feature: {
                        saveAsImage: {
                            show: true,
                            pixelRatio: 2, // 保存图片的分辨率比例，可以设置为大于 1 的值
                            backgroundColor:  'rgba(128, 128, 128, 0)',
                        }
                    }
                },
              tooltip : {
                  trigger: 'item',
                  formatter: '{b}<br/>{c} (元)'
              },
              geo: {//城市地图
                map: 'china',
                type: 'map',
                // show: true,
                roam: false,//禁止拖拽和伸缩 true为可拖拽 
            }, 
            visualMap: {
                min: 1,
                max: 50000000,
                text: ['高', '低'],
                realtime: false,
                calculable: true,
                splitNumber: 5,
                inRange: {
                    color: ['#4FA1A4','#f4f4f4'].reverse()
                },   
            }, 
            series: [
                //地图配置
                { 
                    name: 'china',
                    type: 'map',
                    mapType: 'china',
                    zoom: 1,
                    geoIndex: 1,
                    itemStyle: {
                        normal: {
                            borderWidth: 0.5,//区域边框宽度
                            borderColor: '#A0A0A0',//区域边框颜色
                            // areaColor:"#DCDCDC",//区域颜色
                        },
                        emphasis: {
                            borderWidth: .5,
                            borderColor: '#F8CF73',
                            areaColor:"#F8CF73",
                            color:'#000000'
                        }
                    }, 
                    data: bmapList
                }
            ]
          };
          option && myChart.setOption(option,true);
        }, 
        getCharList(barCharLists){
            let self = this; 

            if(barCharLists != null && barCharLists.length > 0){
                barCharLists.forEach((i)=>{
                    if(i.analysisType == 'bar'){
                        if(i.list != null && i.list != ''){
                            self.getBar(i.id,i.analysisChartName,i.list);
                        }
                    }else if(i.analysisType == 'pie'){
                        if(i.list != null && i.list != ''){
                            self.bmapList = []; 
                            let bmapList11 = [];
                            if(i.list.itemXAxis != null && i.list.itemXAxis.length > 0){
                                if(i.list.itemXAxis[0].data != null && i.list.itemXAxis[0].data != ''){
                                    i.list.itemXAxis[0].data.forEach((j,index)=>{
                                        j = j.replace("省","").replace("市","").replace("自治区","").replace("回族","").replace("壮族","").replace("维吾尔",""); 
                                        let item = {
                                            name:j,
                                            value:i.list.itemYAxis[0].data[index]
                                        } 
                                        self.bmapList.push(item);

                                        let item1 = [
                                            j,i.list.itemYAxis[0].data[index] 
                                        ]
                                        bmapList11.push(item1);
                                    })
                                } 
                            } 
                            self.getPie(i.id,i.analysisChartName,self.bmapList);  
                        } 
                    }else if(i.analysisType == 'barandline'){
                        if (i.list != null && i.list != ''){
                            self.getBarAndLine(i.id,i.analysisChartName,i.list);
                        }
                    }else if(i.analysisType == 'barmore'){
                        if(i.list != null && i.list != ''){
                            self.getBarMore(i.id,i.analysisChartName,i.list);
                        }
                    }else if(i.analysisType == 'scatter'){
                        if(i.list != null && i.list != ''){
                            let scatterList = [];
                            if(i.list.itemXAxis != null && i.list.itemXAxis.length > 0){
                                i.list.itemXAxis[0].data.forEach((j,index)=>{ 
                                    let item = [
                                        j,i.list.itemYAxis[0].data[index],i.list.itemYAxis[1].data[index],i.list.itemYAxis[1].name
                                    ]
                                    scatterList.push(item);
                                }) 
                            }
                            self.getScatter(i.id,i.analysisChartName,scatterList);
                        }
                    }else if(i.analysisType == 'scattersome'){
                        if(i.list != null && i.list != ''){ 
                            let scatterSomeList = [];
                            if(i.list.itemXAxis != null && i.list.itemXAxis.length > 0){
                                i.list.itemXAxis[0].data.forEach((j,index)=>{ 
                                    let item1 = [
                                        j,i.list.itemYAxis[0].data[index] 
                                    ]
                                    scatterSomeList.push(item1);
                                }) 
                            }
                            self.getScatterSome(i.id,i.analysisChartName,scatterSomeList); 
                        }
                    }else if(i.analysisType == 'barmoreandline'){
                        if(i.list != null && i.list != ''){
                            self.getScatterSomeAndLine(i.id,i.analysisChartName,i.list);
                        }
                    }else if(i.analysisType == 'bmap'){
                        if(i.list != null && i.list != ''){ 
                            self.bmapList = []; 
                            if(i.list.itemXAxis[0].data != null && i.list.itemXAxis[0].data.length > 0){
                                i.list.itemXAxis[0].data.forEach((j,index)=>{
                                    j = j.replace("省","").replace("市","").replace("自治区","").replace("回族","").replace("壮族","").replace("维吾尔",""); 
                                    let item = {
                                        name:j,
                                        value:i.list.itemYAxis[0].data[index]
                                    } 
                                    self.bmapList.push(item);
                                })
                            }
                            self.getBmap(i.id,i.analysisChartName,self.bmapList);
                        }
                    }
                })
            } 
        },
    },
    watch: {
    },
    mounted() {   
    },
    created() {
      let self = this; 
      if(self.barCharLists.length == 1){
            self.width.width = '100% !important';
        }
       setTimeout(function(){
         self.getCharList(self.barCharLists);
      },1000)
    }
}
</script>

<style scoped>
.bar-all-sty { 
  width: 100%;
  display: inline-block;
  background: #ffffff;
  height: auto;
}
.bar-back {
    width:50%;
    height: 450px;
    float: left;
    background: #E9EEF3;
}
.bar-sty {
    margin: 4px 0px 0px 0px;
    /* width: 100%; */
    height: 446px;
    background: #ffffff;
    /* margin: 5px; */
}
</style>